import { computed, makeObservable, observable } from "mobx"

import { TokenStore } from "@/domains/tokens"

export class QuickSelectTokenStore {
  cachedTokens = observable.array<TokenStore>([])

  constructor(tokens: TokenStore[] = []) {
    makeObservable(this, {
      tokens: computed,
    })

    // Store references to the TokenStore instances directly
    this.cachedTokens.replace(tokens)
  }

  private sortTokensByBalance(tokens: TokenStore[]): TokenStore[] {
    return tokens.slice().sort((a, b) => {
      const balanceA = a.balance
      const balanceB = b.balance
      return Number(balanceB - balanceA)
    })
  }

  // Pure computed getter - no side effects!
  get tokens(): TokenStore[] {
    return this.sortTokensByBalance(this.cachedTokens.slice())
  }

  // Update tokens (useful if tokens are added to repository later)
  updateTokens(tokens: TokenStore[]): void {
    this.cachedTokens.replace(tokens)
  }
}
